import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ModalConfig } from 'src/app/_metronic/partials';
import { ActionType } from 'src/app/core/enums/action-type.enum';
import { ExcelUploaderModalComponent } from '../excel-uploader-modal/excel-uploader-modal.component';

@Component({
  selector: 'app-excel-uploader',
  templateUrl: './excel-uploader.component.html',
  styleUrl: './excel-uploader.component.css'
})
export class ExcelUploaderComponent {
  @Input({ required: true }) modelKeys: { title: string, isRequired: boolean, label: string }[] = [];
  @Input() enablePreviewMode: boolean = true;
  /** Only choose Excel sheet; hide column mapping (bulk import with standard template). */
  @Input() sheetSelectionOnly = false;
  @Input() warningMessage: string = 'PRODUCTS.WARNING.ROW_LIMIT';
  @Input() hideButton: boolean = false;

  @Output() dataCreated = new EventEmitter<any>();

  @ViewChild('fileInput') fileInputRef: ElementRef<HTMLInputElement> | null = null;

  modalConfig: ModalConfig = {
    modalTitle: '',
    submitButtonLabel: '',
    dismissButtonLabel: '',
    hideCloseButton: () => true,
    width: 50,
    backdrop: 'static',
    actionType: ActionType.CREATE,
    modalOptions: {
      size: 'xl',
      centered: true,
      backdrop: 'static',
    },
  };

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  onFileChange(event: any) {
    const target: DataTransfer = <DataTransfer>event.target;
    if (target.files.length !== 1) return;

    const file = target.files[0];
    
    // Check file size (20MB = 20 * 1024 * 1024 bytes)
    const maxSizeInBytes = 20 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      this.toastr.error(
        this.translate.instant('IMPORT.ERROR.FILE_TOO_LARGE'),
        this.translate.instant('IMPORT.ERROR.FILE_TOO_LARGE_TITLE')
      );
      return;
    }

    this.openModalForCreateProduct(file);
  }

  openFileDialog(): void {
    this.fileInputRef?.nativeElement?.click();
  }

  constructor(private modalService: NgbModal, private toastr: ToastrService, private translate: TranslateService) { }

  async openModalForCreateProduct(target: any) {
    this.modalConfig.actionType = ActionType.CREATE;
    const modalRef = this.modalService.open(
      ExcelUploaderModalComponent,
      {
        ...this.modalConfig.modalOptions,
        windowClass: 'responsive-modal'
      }
    );

    modalRef.componentInstance.modalConfig = this.modalConfig;
    modalRef.componentInstance.modelKeys = this.modelKeys;
    modalRef.componentInstance.target = target;
    modalRef.componentInstance.enablePreviewMode = this.enablePreviewMode;
    modalRef.componentInstance.sheetSelectionOnly = this.sheetSelectionOnly;
    modalRef.componentInstance.warningMessage = this.warningMessage;

    modalRef.result
      .then((result) => {
        this.dataCreated.emit(result);
      })
      .catch((reason) => {
        console.log('Modal dismissed with reason:', reason);
      });
  }
}
